module.exports = __webpack_public_path__ + "img/bg-app-list-outlink.e295f0e6.png";